import React, {useState} from 'react'
import { useEffect } from 'react'
import cross from '../images/transparentCross.png'
import check from '../images/transparentCheck.png'
const determineOffboarded = (offboradedContent) => {
    switch (offboradedContent) {
        case 'OffboardedForever':
            return false
        case 'Active':
            return true
        case 'verified':
            return true    
        case null:
            return true        
        default:
            return false
    }
}

const DriverDocumentsCompliance = (props) => {
    const [ returnArray, setReturnArray ] = useState([])
    const [ driverNames, setDriverNames ] = useState([])

    // function for making abbreviations out of the country names
    const abbreviateMe = (inputString) => {
        let countryObj = {
         'Afghanistan': 'AF',
         'Albania': 'AL',
         'Algeria': 'DZ',
         'Aland Islands': 'AX',
         'American Samoa': 'AS',
         'Anguilla': 'AI',
         'Andorra': 'AD',
         'Angola': 'AO',
         'Antilles': 'AN',
         'Antigua and Barbuda': 'AG' ,
         'Antarctica': 'AQ',
         'Argentina': 'AR',
         'Armenia': 'AM',
         'Australia': 'AU',
         'Austria': 'AT',
         'Aruba': 'AW',
         'Azerbaijan': 'AZ',
         'Bosnia and Herzegovina': 'BA' ,
         'Barbados': 'BB',
         'Bangladesh': 'BD',
         'Belgium': 'BE',
         'Burkina Faso': 'BF',
         'Bulgaria': 'BG',
         'Bahrain': 'BH',
         'Burundi': 'BI',
         'Benin': 'BJ',
         'Bermuda': 'BM',
         'Brunei Darussalam' : 'BN',
         'Bolivia': 'BO',
         'Brazil': 'BR',
         'Bahamas': 'BS',
         'Bhutan': 'BT',
         'Bouvet Island': 'BV',
         'Botswana': 'BW',
         'Belarus': 'BV',
         'Belize': 'BZ',
         'Cambodia': 'KH',
         'Cameroon': 'CM',
         'Canada': 'CA',
         'Cape Verde': 'CV',
         'Central African Republic': 'CF' ,
         'Chad': 'TD',
         'Chile': 'CL',
         'China': 'CN',
         'Christmas Island': 'CX',
         'Cocos Islands': 'CC',
         'Colombia': 'CO',
         'Congo': 'CG',
         "Cote D Ivoire": 'CI',
         'Cook Islands': 'CK',
         'Costa Rica': 'CR',
         'Croatia': 'HR',
         'Cuba': 'CU',
         'Cyprus': 'CY',
         'Czech Republic': 'CZ',
         'Democratic Republic of the Congo': 'CD' ,
         'Djibouti': 'DJ',
         'Denmark': 'DK',
         'Dominica': 'DM',
         'Dominican Republic': 'DO',
         'Ecuador': 'EC',
         'Egypt': 'EG',
         'El Salvador': 'SV',
         'East Timor': 'TP',
         'Estonia': 'EE',
         'Equatorial Guinea': 'GQ',
         'Eritrea': 'ER',
         'Ethiopia': 'ET',
         'Finland': 'FI',
         'Fiji': 'FJ',
         'Falkland Islands': 'FK',
         'Federated States of Micronesia': 'FM',
         'Faroe Islands': 'FO',
         'France': 'FR',
         'French Guiana': 'GF',
         'French Polynesia': 'PF',
         'Gabon': 'GA',
         'Gambia': 'GM',
         'Germany': 'DE',
         'Ghana': 'GH',
         'Gibraltar': 'GI',
         'Great Britain': 'GB',
         'Grenada': 'GD',
         'Georgia': 'GE',
         'Greece': 'GR',
         'Greenland': 'GL',
         'Guinea': 'GN',
         'Guadeloupe': 'GP',
         'S. Georgia and S. Sandwich Islands': 'GS',
         'Guatemala': 'GT',
         'Guam': 'GU',
         'Guinea-Bissau': 'GW',
         'Guyana': 'GY',
         'Hong Kong': 'HK',
         'Heard Island and McDonald Islands': 'HM',
         'Honduras': 'HN',
         'Haiti': 'HT',
         'Hungary': 'HU',
         'Indonesia': 'ID',
         'Ireland': 'IE',
         'Israel': 'IL',
         'India': 'IN',
         'British Indian Ocean Territory': 'IO' ,
         'Iraq': 'IQ',
         'Iran': 'IR',
         'Italy': 'IT',
         'Jamaica': 'JM',
         'Jordan': 'JO',
         'Japan': 'JP',
         'Kenya': 'KE',
         'Kyrgyzstan': 'KG',
         'Kiribati': 'KI',
         'Comoros': 'KM',
         'Saint Kitts and Nevis': 'KN',
         'Korea': 'KR',
         'Kuwait': 'KW',
         'Cayman Islands': 'KY',
         'Kazakhstan': 'KZ',
         'Laos': 'LA',
         'Lebanon': 'LB',
         'Saint Lucia': 'LC',
         'Liechtenstein': 'LI',
         'Sri Lanka': 'LK',
         'Liberia': 'LR',
         'Lesotho': 'LS',
         'Lithuania': 'LT',
         'Luxembourg': 'LU',
         'Latvia': 'LV',
         'Libya': 'LY',
         'Macedonia': 'MK',
         'Macao': 'MO',
         'Madagascar': 'MG',
         'Malaysia': 'MY',
         'Mali': 'ML',
         'Malawi': 'MW',
         'Mauritania': 'MR',
         'Marshall Islands': 'MH',
         'Martinique': 'MQ',
         'Mauritius': 'MU',
         'Mayotte': 'YT',
         'Malta': 'MT',
         'Mexico': 'MX',
         'Morocco': 'MA',
         'Monaco': 'MC',
         'Moldova': 'MD',
         'Mongolia': 'MN',
         'Myanmar': 'MM',
         'Northern Mariana Islands': 'MP' ,
         'Montserrat': 'MS',
         'Maldives': 'MV',
         'Mozambique': 'MZ',
         'Namibia': 'NA',
         'New Caledonia': 'NC',
         'Niger': 'NE',
         'Norfolk Island': 'NF',
         'Nigeria': 'NG',
         'Nicaragua': 'NI',
         'Netherlands': 'NL',
         'Norway': 'NO',
         'Nepal': 'NP',
         'Nauru': 'NR',
         'Niue': 'NU',
         'New Zealand': 'NZ',
         'Oman': 'OM',
         'Panama': 'PA',
         'Peru': 'PE',
         'Papua New Guinea': 'PG',
         'Philippines': 'PH',
         'Pakistan': 'PK',
         'Poland': 'PL',
         'Saint Pierre and Miquelon': 'PM',
         'Serbia and Montenegro': 'CS',
         'Pitcairn': 'PN',
         'Puerto Rico': 'PR',
         'Palestinian Territory': 'PS',
         'Portugal': 'PT',
         'Palau': 'PW',
         'Paraguay': 'PY',
         'Qatar': 'QA',
         'Reunion': 'RE',
         'Romania': 'RO',
         'Russia': 'RU',
         'Rwanda': 'RW',
         'Saudi Arabia': 'SA',
         'Samoa': 'WS',
         'Saint Helena': 'SH',
         'Saint Vincent and the Grenadines': 'VC',
         'San Marino': 'SM',
         'Sao Tome and Principe': 'ST',
         'Senegal': 'SN',
         'Seychelles': 'SC',
         'Sierra Leone': 'SL',
         'Singapore': 'SG',
         'Slovakia': 'SK',
         'Slovenia': 'SI',
         'Solomon Islands': 'SB',
         'Somalia': 'SO',
         'South Africa': 'ZA',
         'Spain': 'ES',
         'Sudan': 'SD',
         'Suriname': 'SR',
         'Svalbard and Jan Mayen': 'SJ',
         'Sweden': 'SE',
         'Switzerland': 'CH',
         'Syria': 'SY',
         'USSR': 'SU',
         'Swaziland': 'SZ',
         'Taiwan': 'TW',
         'Tanzania': 'TZ',
         'Tajikistan': 'TJ',
         'Thailand': 'TH',
         'Timor-Leste': 'TL',
         'Togo': 'TG',
         'Tokelau': 'TK',
         'Tonga': 'TO',
         'Trinidad and Tobago': 'TT',
         'Tunisia': 'TN',
         'Turkey': 'TR',
         'Turkmenistan': 'TM',
         'Turks and Caicos Islands': 'TC',
         'Tuvalu': 'TV',
         'Ukraine': 'UA',
         'Uganda': 'UG',
         'United Arab Emirates': 'AE',
         'United Kingdom': 'UK',
         'United States': 'US',
         'United States Minor Outlying Islands': 'UM',
         'Uruguay': 'UY',
         'Uzbekistan': 'UZ',
         'Vanuatu': 'VU',
         'Vatican City State': 'VA',
         'Venezuela': 'VE',
         'Virgin Islands (British)': 'VG',
         'Virgin Islands (U.S.)': 'VI',
         'Vietnam': 'VN',
         'Wallis and Futuna': 'WF',
         'Western Sahara': 'EH',
         'Yemen': 'YE',
         'Yugoslavia': 'YU',
         'Zambia': 'ZM',
         'Zaire': 'ZR',
         'Zimbabwe' : 'ZW'
        }

        if (countryObj[inputString]) {
            return countryObj[inputString]
        }
        else {
            return inputString.slice(0,2).toUpperCase()
        }
    }

    useEffect( () => {
        if (props.data) {
            let localObj = {...props.data}
            let localArrayDrivers = [...localObj.drivers]
            localArrayDrivers.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
            setReturnArray(['null'])
            let localArray = []
            localArrayDrivers.forEach( (driver, driverID) => { 
                if (determineOffboarded(driver.status) && driver.location === props.selectedCity) { 
                    localArray.push(driver)
                }
            })
            setDriverNames(localArray)
            let localCheckArray = []
            localArray.forEach( (driver, driverID) => {
                let localArrayDriver = []
                    for (let i = 0; i < 13; i++) {
                        if (i === 0) {
                            localArrayDriver.push(
                                <div key={driverID} className='drivers_for_compliance_check_documents_missing' id='leftMost'>
                                    Missing
                                </div>
                            )
                        } else {
                            localArrayDriver.push(
                                <div key={driverID} className='drivers_for_compliance_check_documents_missing'>
                                    Missing
                                </div>
                            )
                        }
                    }
                    localArrayDriver.push(
                        <div key={driverID} className='drivers_for_compliance_check_documents_false'>
                            <img src={cross}  className='complianceImages' alt='this is a cross'/>
                        </div>
                    )
                    localArrayDriver.unshift(
                        <div key={driverID} className='labels_for_compliance_check_name'>
                            {driver.name}
                        </div>
                    )
                    let latestVersion = 0
                    driver.imgArray.forEach( (image, imageId) => {
                        if (!image.storageBool) {
                            if ((image.name === 'Passport' || image.name === 'ID' || image.name === 'Birth Certificate') && image.verified === 'True') {
                                localArrayDriver[1] = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents' id='leftMost'>
                                        {image.name}
                                    </div>
                                )
                                localArrayDriver[2] = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents'>
                                        {image.countryOfIssue ? abbreviateMe(image.countryOfIssue) : 'not entered'}
                                    </div>
                                )
                                localArrayDriver[3] = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents'>
                                        {new Date(image.expiryDate).toLocaleDateString('en-GB') !== '1/3/2030' ? new Date(image.expiryDate).toLocaleDateString('en-GB'):'n/a' }
                                    </div>
                                )
                            } else if ((image.name === 'Passport' || image.name === 'ID' || image.name === 'Birth Certificate') && image.verified === null){
                                localArrayDriver[1] = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents_two' id='leftMost'>
                                        {image.name}
                                    </div>
                                )
                                localArrayDriver[2] = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents_two'>
                                        {image.countryOfIssue ? abbreviateMe(image.countryOfIssue) : 'not entered'}
                                    </div>
                                )
                                localArrayDriver[3] = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents_two'>
                                        {new Date(image.expiryDate).toLocaleDateString('en-GB') !== '1/3/2030' ? new Date(image.expiryDate).toLocaleDateString('en-GB'):'n/a' }
                                    </div>
                                )
                            }
                            if (image.name === 'Visa' && image.verified === 'True') {
                                localArrayDriver[4]  = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents'>
                                        {new Date(image.expiryDate).toLocaleDateString('en-GB') !== '1/3/2030' ? new Date(image.expiryDate).toLocaleDateString('en-GB'):'n/a' }
                                    </div>
                                )
                            } else if (image.name === 'Visa' && image.verified === null) {
                                localArrayDriver[4]  = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents_two'>
                                        {new Date(image.expiryDate).toLocaleDateString('en-GB') !== '1/3/2030' ? new Date(image.expiryDate).toLocaleDateString('en-GB'):'n/a' }
                                    </div>
                                )
                            }
                            if ((image.name === 'Driving licence Front' || image.name === 'Driving licence Back') && image.verified === 'True') {
                                localArrayDriver[5]  = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents' id='countryNames'>
                                        {image.countryOfIssue !== 'n/a'? abbreviateMe(image.countryOfIssue)  : 'n/a'}
                                    </div>
                                )
                                localArrayDriver[6]  = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents'>
                                        {new Date(image.expiryDate).toLocaleDateString('en-GB') !== '1/3/2030' ? new Date(image.expiryDate).toLocaleDateString('en-GB'):'n/a' }
                                    </div>
                                )
                            } else if ((image.name === 'Driving licence Front' || image.name === 'Driving licence Back') && image.verified === null) {
                                localArrayDriver[5]  = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents_two'>
                                        {image.countryOfIssue !== 'n/a'? abbreviateMe(image.countryOfIssue) : 'n/a'}
                                    </div>
                                )
                                localArrayDriver[6]  = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents_two'>
                                        {new Date(image.expiryDate).toLocaleDateString('en-GB') !== '1/3/2030' ? new Date(image.expiryDate).toLocaleDateString('en-GB'):'n/a' }
                                    </div>
                                )
                            }
                            if (image.name === 'DVLA Check') {
                                if (image.image_id > latestVersion) {
                                    latestVersion = image.image_id
                                    if (image.name === 'DVLA Check' && image.verified === 'True') {
                                        localArrayDriver[7]  = (
                                            <div key={driverID} className='drivers_for_compliance_check_documents'>
                                                {new Date(image.expiryDate).toLocaleDateString('en-GB') !== '1/3/2030' ? new Date(image.expiryDate).toLocaleDateString('en-GB'):'n/a' }
                                            </div>
                                        )
                                    } else if (image.name === 'DVLA Check' && image.verified === null) {
                                        localArrayDriver[7]  = (
                                            <div key={driverID} className='drivers_for_compliance_check_documents_two'>
                                                {new Date(image.expiryDate).toLocaleDateString('en-GB') !== '1/3/2030' ? new Date(image.expiryDate).toLocaleDateString('en-GB'):'n/a' }
                                            </div>
                                        )
                                    }
                                }
                            }
                            if (image.name === 'BGC' && image.verified === 'True') {
                                localArrayDriver[8]  = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents_check'>
                                        <img src={check}  className='complianceImages' alt='this is a check'/>
                                    </div>
                                )
                            } else if (image.name === 'BGC' && image.verified === null) {
                                localArrayDriver[8]  = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents_check_two'>
                                        <img src={check}  className='complianceImages' alt='this is a check'/>
                                    </div>
                                )
                            }
                            if (image.name === 'D&A test' && image.verified === 'True') {
                                localArrayDriver[9]  = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents'>
                                        {new Date(image.expiryDate).toLocaleDateString('en-GB') !== '1/3/2030' ? new Date(image.expiryDate).toLocaleDateString('en-GB'):'n/a' }
                                    </div>
                                )
                            } else if (image.name === 'D&A test' && image.verified === null) {
                                localArrayDriver[9]  = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents_two'>
                                        {new Date(image.expiryDate).toLocaleDateString('en-GB') !== '1/3/2030' ? new Date(image.expiryDate).toLocaleDateString('en-GB'):'n/a' }
                                    </div>
                                )
                            }
                            if (image.name === 'Application Package' && image.verified === 'True') {
                                localArrayDriver[10]  = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents_check'>
                                        <img src={check}  className='complianceImages' alt='this is a check'/>
                                    </div>
                                )
                            } else if (image.name === 'Application Package' && image.verified === null) {
                                localArrayDriver[10]  = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents_check_two'>
                                        <img src={check}  className='complianceImages' alt='this is a check'/>
                                    </div>
                                )
                            }
                            if (image.name === 'NIN' && image.verified === 'True') {
                                localArrayDriver[11]  = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents_check'>
                                        <img src={check}  className='complianceImages' alt='this is a check'/>
                                    </div>
                                )
                            } else if (image.name === 'NIN' && image.verified === null) {
                                localArrayDriver[11]  = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents_check_two'>
                                        <img src={check}  className='complianceImages' alt='this is a check'/>
                                    </div>
                                )
                            }
                            if (image.name === 'UTR' && image.verified === 'True') {
                                localArrayDriver[12]  = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents_check'>
                                        <img src={check}  className='complianceImages' alt='this is a check'/>
                                    </div>
                                )
                            } else if (image.name === 'UTR' && image.verified === null) {
                                localArrayDriver[12]  = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents_check_two'>
                                        <img src={check}  className='complianceImages' alt='this is a check'/>
                                    </div>
                                )
                            }
                            if (image.name === 'POA' && image.verified === 'True') {
                                localArrayDriver[13]  = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents_check'>
                                        <img src={check}  className='complianceImages' alt='this is a check'/>
                                    </div>
                                )
                            } else if (image.name === 'POA' && image.verified === null) {
                                localArrayDriver[13]  = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents_check_two'>
                                        <img src={check}  className='complianceImages' alt='this is a check'/>
                                    </div>
                                )
                            }
                            if (image.name === 'VAT') {
                                localArrayDriver[14]  = (
                                    <div key={driverID} className='drivers_for_compliance_check_documents_check'>
                                        <img src={check}  className='complianceImages' alt='this is a check'/>
                                    </div>
                                )
                            }
                        }
                    })
                    localCheckArray.push(
                        <div className='vanHolder'>
                            {localArrayDriver}
                        </div>
                    )
                })
            setReturnArray(localCheckArray)
        } else {
            setReturnArray(
                <div className='containerForLoader'>
                    <div class="spinner">
                        <div class="bounce1"></div>
                        <div class="bounce5"></div>
                        <div class="bounce4"></div>
                        <div class="bounce3"></div>
                        <div class="bounce2"></div>
                    </div>
                </div>
            )
        }   
    }, [props.selectedCity, props.data])

    var content
    if (returnArray.length > 0) {
        content = returnArray
    } else {
        content = (
            <div className='complianceLoading'>
                <div className='containerForLoader'>
                    <div class="spinner">
                        <div class="bounce1"></div>
                        <div class="bounce5"></div>
                        <div class="bounce4"></div>
                        <div class="bounce3"></div>
                        <div class="bounce2"></div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            {content}
        </>
    )
}

export default DriverDocumentsCompliance